module.exports = __webpack_public_path__ + "static/media/Background_1.5876043c.svg";